<template>
    <div class="paypal-account-page">
        <div class="header">
            <div class="title">PayPal账户管理</div>
            <el-button type="primary" size="small" @click="handleAdd">新增PayPal账户</el-button>
        </div>

        <el-table :data="tableData" border stripe style="width:100%;" v-loading="loading">
            <el-table-column prop="id" label="ID" width="100" align="center" />
            <el-table-column prop="accountName" label="账户名称" align="center" />
            <el-table-column label="操作" width="160" align="center">
                <template slot-scope="{row}">
                    <el-button type="primary" size="mini" @click="handleEdit(row)">修改</el-button>
                </template>
            </el-table-column>
        </el-table>

        <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="520px" :close-on-click-modal="false">
            <el-form ref="form" :model="form" :rules="rules" label-width="110px">
                <el-form-item label="账户名称" prop="accountName">
                    <el-input v-model.trim="form.accountName" placeholder="请输入PayPal账户名称" />
                </el-form-item>
                <el-form-item label="Client ID" prop="clientId">
                    <el-input v-model.trim="form.clientId" placeholder="请输入PayPal Client ID" />
                </el-form-item>
                <el-form-item label="Client Secret" prop="clientSecret">
                    <el-input v-model.trim="form.clientSecret"
                        placeholder="请输入PayPal Client Secret" />
                </el-form-item>
            </el-form>

            <span slot="footer">
                <el-button @click="dialogVisible = false">取消</el-button>
                <el-button type="primary" :loading="submitLoading" @click="handleSubmit">
                    {{ submitLoading ? '验证中...' : '确定' }}
                </el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { Baseurl, ajaxPost } from "@/api/api/api";

export default {
    name: "PaypalAccount",
    data() {
        return {
            loading: false,
            submitLoading: false,
            dialogVisible: false,
            dialogTitle: "新增PayPal账户",
            tableData: [],
            form: {
                id: null,
                accountName: "",
                clientId: "",
                clientSecret: ""
            },
            rules: {
                accountName: [
                    { required: true, message: "请输入账户名称", trigger: "blur" }
                ],
                clientId: [
                    { required: true, message: "请输入Client ID", trigger: "blur" }
                ],
                clientSecret: [
                    { required: true, message: "请输入Client Secret", trigger: "blur" }
                ]
            }
        };
    },
    created() {
        this.getList();
    },
    methods: {
        getList() {
            this.loading = true;
            const url = Baseurl + "paypalAccountController/getList";
            ajaxPost(url, {}).then(res => {
                if (res.data.code == 200) {
                    this.tableData = res.data.data || [];
                } else {
                    this.$message.error(res.data.msg || "查询失败");
                }
            }).catch(err => {
                console.error(err);
                this.$message.error("查询PayPal账户失败");
            }).finally(() => {
                this.loading = false;
            });
        },

        handleAdd() {
            this.dialogTitle = "新增PayPal账户";
            this.form = {
                id: null,
                accountName: "",
                clientId: "",
                clientSecret: ""
            };
            this.dialogVisible = true;
            this.$nextTick(() => {
                if (this.$refs.form) this.$refs.form.clearValidate();
            });
        },

        handleEdit(row) {
            this.dialogTitle = "修改PayPal账户";
            this.form = {
                id: row.id,
                accountName: row.accountName,
                clientId: "",
                clientSecret: ""
            };
            this.dialogVisible = true;
            this.$nextTick(() => {
                if (this.$refs.form) this.$refs.form.clearValidate();
            });
        },

        handleSubmit() {
            this.$refs.form.validate(valid => {
                if (!valid) return;

                this.submitLoading = true;
                const isEdit = this.form.id != null;
                const url = Baseurl + (isEdit ? "paypalAccountController/update" : "paypalAccountController/add");

                ajaxPost(url, this.form).then(res => {
                    if (res.data.code == 200) {
                        this.$message.success(isEdit ? "修改成功" : "添加成功");
                        this.dialogVisible = false;
                        this.getList();
                    } else {
                        this.$message.error(res.data.msg || (isEdit ? "修改失败" : "添加失败"));
                    }
                }).catch(err => {
                    console.error(err);
                    this.$message.error(isEdit ? "修改失败" : "添加失败");
                }).finally(() => {
                    this.submitLoading = false;
                });
            });
        }
    }
};
</script>

<style scoped>
.paypal-account-page {
    padding: 20px;
    background: #fff;
}

.header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 16px;
}

.title {
    font-size: 18px;
    font-weight: bold;
    color: #303133;
}

.tip {
    margin-left: 110px;
    margin-top: -5px;
    padding: 10px 12px;
    background: #f4f4f5;
    color: #909399;
    font-size: 13px;
    line-height: 20px;
    border-radius: 4px;
}
</style>